<template>
  <div class="un-login">
    <div class="login-btn" @click.stop="handleClickLogin">登录/注册</div>
    <p class="desc">登录名企校招小程序，查看更多校招职位</p>
  </div>
</template>

<script>
  import {loginMixin} from "../../../assets/js/mixin/global";
  export default {
    name: "unlogin",
    mixins: [loginMixin],
    methods:{
      handleClickLogin(){
        this.needLogin()
      }
    }
  }
</script>

<style scoped lang="scss">
.un-login{
  position: relative;
  z-index: 10;
  width: 375px;
  height: 244px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%,#FFFFFF 40%, #FFFFFF 100%);
  /*background: red;*/
  margin-top: -99px;
  padding-top: 130px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .login-btn{
    width: 175px;
    height: 42px;
    background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
    border-radius: 21px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 42px;
    text-align: center;
    margin-bottom: 15px;
  }
  .desc{
    font-size: 14px;
    font-weight: 400;
    color: #9C9C9C;
    line-height: 21px;
    text-align: center;
  }
}
</style>
